<script src="./BaseMoney.js"></script>

<template>
  <span data-test="product-original-price">
    {{ formattedMoney }}
  </span>
</template>
